var globalMap;
var userMarker; // global variable to hold the user marker
var userLocation; // global variable to store the user's current location

jQuery(document).ready(function () {
  const siteUrl = weissenstadt_bundle_object.siteurl;
  const themeUrl = siteUrl + "/wp-content/themes/weissenstadt";

  // var map = L.map('citytourmap').setView([51.505, -0.09], 13);
  // var map = L.map('citytourmap');

  var map = L.map("citytourmap", {
    gestureHandling: true,
    renderer: L.canvas(),
  });

  // Assign the map object to the global variable
  globalMap = map;

  map.addControl(
    new L.Control.Fullscreen({
      title: {
        false: "Vollbildmodus starten",
        true: "Vollbildmodus beenden",
      },
    })
  );

  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  }).addTo(map);

  var bounds = new L.LatLngBounds();

  for (var i = 0; i < locations.length; i++) {
    $indexlink = i + 1;
    var appleMapsRouteUrl =
      "https://maps.apple.com/?daddr=" +
      encodeURIComponent(locations[i].lat + "," + locations[i].lng);
    var googleMapsRouteUrl =
      "https://www.google.com/maps/dir/?api=1&destination=" +
      encodeURIComponent(locations[i].lat + "," + locations[i].lng);

    var popupContent = '<div style="width: 250px;">';
    popupContent += "<h3>" + locations[i].title + "</h3>";
    if (locations[i].excerpt) {
      popupContent += "<p>" + locations[i].excerpt + "</p>";
    }
    if (locations[i].path) {
      popupContent += `
            <div class="citytourpopuplinks">
                <a class="citytour-link-learnmore" href="/digitale-stadtfuehrung/#${$indexlink}" data-index="${$indexlink}">
                <svg style="fill:white;" xmlns="http://www.w3.org/2000/svg" height="1.5em" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                    <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"></path>
                                </svg>
                Mehr erfahren
                </a>
                <a class="citytour-link-googlemaps" href="${googleMapsRouteUrl}" target="_blank">
                    <img src="${themeUrl}/img/citytour/googlemaps.png" width="25" height="25" />Google
                </a>
                <br>
                <a class="citytour-link-applemaps" href="${appleMapsRouteUrl}" target="_blank">
                    <img src="${themeUrl}/img/citytour/applemaps.png" width="25" height="25" />Apple
                </a>
            </div>`;
    }

    popupContent += "</div>";

    var marker = L.marker([locations[i].lat, locations[i].lng])
      .addTo(map)
      .bindPopup(popupContent);
    bounds.extend(marker.getLatLng());
  }

  // Fit the map to the bounds
  map.fitBounds(bounds, { padding: [50, 50] });

  function onLocationFound(e) {
    // Creating a divIcon with custom class
    var userIcon = L.divIcon({
      className: "custom-marker",
      iconSize: [22, 22],
      iconAnchor: [11, 11], // Adjusted to center the icon properly
    });

    // If the user's location has changed, update the marker
    if (!userLocation || !e.latlng.equals(userLocation)) {
      userLocation = e.latlng;

      if (userMarker) {
        // if userMarker exists, remove it before adding a new one
        map.removeLayer(userMarker);
      }

      userMarker = L.marker(e.latlng, { icon: userIcon })
        .addTo(map)
        .bindPopup("Dein Standort"); // Removed .openPopup() to prevent automatic opening of the popup
    }
  }

  function onLocationError(e) {
    if (e.code === e.TIMEOUT) {
      console.error("Location timeout error: ", e.message);
    } else {
      alert(e.message);
    }
  }

  map.on("locationfound", onLocationFound);
  map.on("locationerror", onLocationError);

  var isWatching = false; // Variable to keep track of the geolocation watch status

  L.control.locate = L.Control.extend({
    options: {
      position: "bottomleft",
    },

    onAdd: function (map) {
      var container = L.DomUtil.create(
        "div",
        "leaflet-control-locate leaflet-bar leaflet-control"
      );

      var link = L.DomUtil.create("a", "", container);
      link.href = "#";
      link.title = "Meinen Standort anzeigen";
      link.innerHTML = `

            <svg style="fill:#555; margin-left:-2px; margin-top:-3px" xmlns="http://www.w3.org/2000/svg" height="1.9em" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"/></svg>
            `;
      link.style.backgroundColor = "white";
      link.style.padding = "6px";
      link.style.textAlign = "center";

      L.DomEvent.on(link, "click", L.DomEvent.stop).on(
        link,
        "click",
        function () {
          link.classList.add("citytourlocation-loading");

          if (isWatching) {
            link.classList.remove("citytourlocation-active");
            link.classList.remove("citytourlocation-loading");
            map.stopLocate(); // Stops watching the user's location
            isWatching = false;
            if (userMarker) {
              map.removeLayer(userMarker); // Remove the user location marker from the map
            }
          } else {
            link.classList.add("citytourlocation-active");
            map.locate({ watch: true, timeout: 30000 }); // Removed setView option here
            map.once("locationfound", function (e) {
              // Use map.once to set the view only once when location tracking is enabled
              map.setView(e.latlng, 16);
            });
            isWatching = true;
          }
        }
      );

      function hideLoading() {
        link.classList.remove("citytourlocation-loading");
      }

      map.on("locationfound", hideLoading);
      map.on("locationerror", hideLoading);

      return container;
    },
  });

  map.addControl(new L.control.locate());
});

function disableFullscreenFunction(index) {
  $(document).trigger("disableFullscreenEvent", [index]);
}

jQuery(document).on("disableFullscreenEvent", function (event, index) {
  // Your code to disable fullscreen here
  if (globalMap.isFullscreen()) {
    globalMap.toggleFullscreen();
  }
});

jQuery(document).ready(function () {
  jQuery(document).on("click", ".citytour-learnmore", function () {
    var index = jQuery(this).data("index");
    jQuery(document).trigger("disableFullscreenEvent", [index]);
  });
});
